export default "__VITE_ASSET__MM_iTIvp__"